<script setup lang="ts">
import { getImageUrl } from '@tools/media-image';

defineProps<{ lines: string[] }>();
</script>

<template>
  <ul class="transports">
    <li
      v-for="line in lines"
      :key="line"
      class="flex"
    >
      <img
        :src="getImageUrl('f13b1efb-2744-43a1-bc0d-d0ed4b5f96e8')"
        :class="`icon-${line}`"
        :alt="line"
      >
    </li>
  </ul>
</template>

<style scoped lang="scss">
.transports {
  @apply m-0;

  @apply p-0;

  @apply flex items-center gap-x-1;

  @apply list-none;

  img {
    @apply size-4;
  }
}
</style>
